import { render, staticRenderFns } from "./DeleteItemsButton.vue?vue&type=template&id=04132601&scoped=true&"
import script from "./DeleteItemsButton.vue?vue&type=script&lang=js&"
export * from "./DeleteItemsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04132601",
  null
  
)

export default component.exports